@if (loading) { <span class="loading-animate height-36 width-full"></span> }
@else         {
  <div class="am-flex-align relative width-full">
    <input id="dashboard-search" #dashboardSearch class="am-flex-1 b-radius-wide-i height-36 width-min-200 width-full" type="text" autocomplete="off"
        [(ngModel)]="searchValue"
          (focusin)=" onSearchValueFocusIn($event.target.value)"
          (focusout)="onSearchValueFocusOut()"
          (input)="   onSearchValueChange($event.target.value)"
          (keydown)=" onSearchValueKeydown($event)">
    @if ( searchValue) { <span class="am-flex-center pl-xs pr-xs pt-s pb-s absolute-right-center font-s pointer icon-cross" (click)="clearSearch()"></span> }
    @if (!searchValue && dashboardSearch !== document?.activeElement) {
      <span class="absolute left-s am-flex-align gap-xxs color-disabled" (click)="dashboardSearch?.focus()">
        <span class="am-flex-center font-icon icon-search"></span>
        <span class="font-s">Suchen...</span>
      </span>
    }
  </div>
}

@if (tooltipItems?.length) {
  @if (loading) { <span class="ml-s loading-animate height-l width-l"></span> }
  @else {
    <span class="tooltip-icon ml-s icon-circle-question" (click)="toasterService.openInfoSearch(tooltipItems)">
      <div class="web-tooltip white short bottom left-sm">
        <span class="tooltip-title">Sie können mit folgenden Parametern suchen:</span>
        <ul class="tooltip-list classic">
          @for (item of tooltipItems; track $index) { <li>{{ item }}</li> }
        </ul>
      </div>
    </span>
  }
}

@if (showSuggestions && suggestions?.length) {
  <ul class="absolute top-full z-1 b-grey b-radius-wide-i width-full mt-s flex-1 width-min-200 bg-white">
    @for (item of suggestions; track item.id) {
      <li class="am-flex p-s gap-m text-s hover-active" (click)="pickSuggestion(item)">
        <span class="am-flex-center font-small-icon icon-tempton-portals"></span>
        <span class="flex-1">{{ item.search_term }}</span>
        <span class="am-flex-center font-l icon-bin hover-active-blue" (click)="deleteSuggestion($event, item)"></span>
      </li>
    }
  </ul>
}
